module.exports = __webpack_public_path__ + "img/mar.ia-grey.1e0828ba.svg";